import { AccountLookup, ContactPersons  } from "./contact.model";
import { getStoredAuth, serverUrl, requestHeaders, requestHeaderWithAccessToken } from "../auth/auth.service";
export async function fetchAccountLookup():Promise<AccountLookup[]> {
  /*
   * Insert your Outlook code here
   * // Example: Call your API
   */
  try {
    const response = await fetch(
      serverUrl + `person/accounts/getlookupaccounts?branchIdList=${getStoredAuth().user.CompanyBranchID}`,
      {
        method: "GET",
        headers: requestHeaderWithAccessToken()
      }
    );
    //console.log("fetchAccountLookup:", await response);
    if (response.ok) return response.json();
  } 
  catch (error) {
    console.error("Error:", error);
    return null;
  }
}
export async function saveContact(entity: ContactPersons):Promise<ContactPersons> {
  try {
    const response = await fetch(
      serverUrl + `Common/ContactPerson/save`,
      {
        method: "POST",
        headers: requestHeaderWithAccessToken(),
        body: JSON.stringify(entity)
      }
    );
    //console.log("saveContact: ", await response);
    if(response.ok) return response.json();
  } 
  catch (error) {
    console.error("Error:", error);
    return null;
  }
}
// Outlook API Functions
export async function getOutlookContacts(): Promise<OutlookContact[]> {
  return new Promise((resolve, reject) => {
    const ewsRequest = buildGetContactsEWSRequest();
    
    Office.context.mailbox.makeEwsRequestAsync(ewsRequest, (result) => {
      if (result.status === Office.AsyncResultStatus.Succeeded) {
        try {
          const contacts = parseContactsFromEWS(result.value);
          resolve(contacts);
        } catch (error) {
          reject(new Error(`Failed to parse contacts: ${error instanceof Error ? error.message : 'Unknown error'}`));
        }
      } else {
        reject(new Error(result.error?.message || 'Failed to get contacts from Outlook'));
      }
    });
  });
}